import { Component, ComponentRef, Injector, NgZone, ViewContainerRef, ViewChild, OnInit, OnDestroy } from '@angular/core';
import { BaseComponentWithDialog } from "../../../admin-panel/base-admin-panel/base-component-with-dialog";
import { EditObjectsComponent } from "../../../admin-panel/Objects/edit-objects.component";
import { CreateObjectsComponent } from "../../../admin-panel/Objects/create-objects.component";
import { JSProxyService } from "../../../../services/jsproxy.service";
import { ObjectGroupViewModel } from "../../../admin-panel/ObjectGroupViewModel";
import { GroupManagementDialogComponent } from "../../../admin-panel/group-management-dialog/group-management-dialog.component";
import { ObjectKeysSyncDialogComponent } from "../../../admin-panel/Keys/objectkeys-sync-dialog/objectkeys-sync-dialog.component";

@Component({
    selector: 'app-devices-editor',
    templateUrl: './devices-editor.component.html',
    styleUrls: ['./devices-editor.component.css'],
    standalone: false
})
export class DeviceEditorComponent extends BaseComponentWithDialog implements OnInit,OnDestroy {

  groupMgmtDialog: ComponentRef<any>;
  @ViewChild("groupMgmtDialog", { read: ViewContainerRef, static: true }) groupsContainer;

  jsProxy: JSProxyService;
  ngZone: NgZone;
  constructor(protected injector: Injector) {
    super(injector);
    this.jsProxy = injector.get(JSProxyService);
    this.ngZone = injector.get(NgZone);
  }
  ngOnInit() {
    this.jsProxy.registerComponent("ObjectsEditor", this, "");
  }
  ngOnDestroy() {
    this.jsProxy.unRegisterComponent("ObjectsEditor");
  }
  public show(id) {
    this.ngZone.run(() => {
      this.prepareModal(EditObjectsComponent);
      this.componentRef.instance.show(id);
    });
  }

  public create() {
    this.prepareModal(CreateObjectsComponent);
    //this.componentRef.instance.open(new ObjectViewModel());
  }

  public createGroup() {
    this.ngZone.run(() => {
      this.groupMgmtDialog = this.dialogService.open(this.groupsContainer, GroupManagementDialogComponent);

      this.groupMgmtDialog.instance.onSubmit.subscribe(() => {
        //let input = this.groupMgmtDialog.instance.object as ObjectGroupViewModel;
        //input.objects = this.groupMgmtDialog.instance.objects.map(driver => driver.Id);

        //this.objectsService.CreateGroup(input).subscribe(() => {
        //    this.syncService.NotifyEntityChanged(this.groupName, input.Name);
        //});
        this.groupMgmtDialog.instance.close();
      });

      this.groupMgmtDialog.instance.open(new ObjectGroupViewModel());
    });
  }

  public showSyncDialod(id) {
    this.prepareModal(ObjectKeysSyncDialogComponent);
    this.componentRef.instance.objectId = id;
    this.componentRef.instance.open();
  }
}
